export default "__VITE_ASSET__REhtna6Y__"